module.exports = __webpack_public_path__ + "img/view-password.08910e49.svg";